  <efx-header-section [hideInMobile]="false">
    <i alt="icon" class="pill-image material-symbols-outlined" efxTooltip efxTooltipMode="dark" efxTooltipPlacement="bottom"> notifications</i>
    data
  </efx-header-section>

